module.exports = __webpack_public_path__ + "static/media/material_preparacion.5b247e31.png";